module.exports = __webpack_public_path__ + "static/adidas-ig-9db56c9cb94ec30f9ad30e87b356b629.mp4";